import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogIn, Search } from "lucide-react";
import { FormCard } from "@/components/FormShell";

export function LostAuthGate({ t }) {
  const location = useLocation();
  const next = encodeURIComponent(`${location.pathname}${location.search}`);
  return (
    <div className="bg-background min-h-[70vh] grid place-items-center px-6 py-16">
      <FormCard icon={Search} title={t("an.lostLoginRequired")} className="max-w-md w-full" bodyClassName="text-center" testid="lost-auth-gate">
        <h1 className="sr-only" data-testid="lost-auth-title">{t("an.lostLoginRequired")}</h1>
        <p className="text-sm text-slate-500" data-testid="lost-auth-desc">{t("an.lostLoginDesc")}</p>
        <Link to={`/mon-compte?next=${next}`}>
          <Button className="mt-6 w-full h-12 rounded-xl font-semibold bg-findo-red hover:bg-findo-red/90 text-white" data-testid="lost-auth-login-btn">
            <LogIn size={17} className="mr-1.5" /> {t("anf.loginCta")}
          </Button>
        </Link>
      </FormCard>
    </div>
  );
}
